/* Rhapsodye reviews widget: store-wide star badge + masonry review grid for product pages.
   Markup (from the theme's Custom Liquid):
     <div data-rrw-badge data-rrw-src="{{ 'reviews-widget.json' | file_url }}"></div>
     <section data-rrw-carousel data-rrw-src="..." id="rhapsodye-reviews"></section>
   Data comes from reviews-widget.json, refreshed daily with /pages/reviews. */
(function () {
  if (window.__rrwLoaded) return;
  window.__rrwLoaded = true;

  var ALL_REVIEWS_URL = '/pages/reviews';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var CSS = [
    '.rrw-badge{display:flex;align-items:center;min-height:22px;margin:2px 0 4px}',
    '.rrw-badge a{display:inline-flex;align-items:center;gap:8px;text-decoration:none;color:#121212;font-size:14px;line-height:1.2;opacity:0;transition:opacity .25s}',
    '.rrw-badge.is-ready a{opacity:1}',
    '.rrw-badge a:hover .rrw-badge__count{text-decoration:underline}',
    '.rrw-stars{position:relative;display:inline-block;font-size:17px;letter-spacing:2px;line-height:1;color:#d9d2ff}',
    '.rrw-stars__on{position:absolute;left:0;top:0;overflow:hidden;white-space:nowrap;color:#6c47ff}',
    '.rrw-badge__avg{font-weight:700}',
    '.rrw-badge__count{color:#555}',
    '.rrw{padding:36px 0 28px;scroll-margin-top:90px}',
    '.rrw *{box-sizing:border-box}',
    '.rrw__head{display:flex;align-items:flex-end;justify-content:space-between;gap:12px;flex-wrap:wrap;margin:0 0 16px}',
    '.rrw__title{font-size:clamp(22px,4vw,28px);font-weight:800;color:#121212;margin:0 0 6px;line-height:1.2}',
    '.rrw__summary{display:flex;align-items:center;gap:8px;font-size:14px;color:#555}',
    '.rrw__all{display:inline-block;padding:10px 20px;border-radius:10px;background:#6c47ff;color:#fff !important;font-weight:700;font-size:14px;text-decoration:none;white-space:nowrap}',
    '.rrw__all:hover{opacity:.9}',
    // the theme drops Custom Liquid blocks into a row flex container that grows to fit its content;
    // pin the block to the page width and give the card strip no say in that width
    'div:has(> .rrw){flex:1 1 100%;min-width:0;width:100%}',
    '.rrw{width:100%}',
    '.rrw__grid{display:flex;gap:14px;align-items:flex-start;width:0;min-width:100%}',
    '.rrw__col{flex:1 1 0;min-width:0;display:flex;flex-direction:column;gap:14px}',
    '.rrw-card{background:#fff;border-radius:10px;box-shadow:0 2px 12px rgba(18,18,18,.08);overflow:hidden;transition:box-shadow .2s}',
    '.rrw-card:hover{box-shadow:0 6px 20px rgba(18,18,18,.13)}',
    '.rrw-card__hero{position:relative;display:block;aspect-ratio:4/5;overflow:hidden;background:#f3f0ff}',
    '.rrw-card__hero img{position:absolute;inset:0;width:100%;height:100%;max-width:none;object-fit:cover;display:block}',
    '.rrw-card__count{position:absolute;right:8px;bottom:8px;background:rgba(18,18,18,.72);color:#fff;font-size:11.5px;font-weight:700;border-radius:100px;padding:3px 9px}',
    '.rrw-card__in{padding:16px 16px 14px}',
    '.rrw-card__name{font-weight:700;color:#121212;font-size:15px;display:flex;align-items:center;gap:6px 8px;flex-wrap:wrap;line-height:1.3}',
    '.rrw-v{display:inline-flex;align-items:center;gap:4px;font-size:12.5px;color:#444;font-weight:500}',
    '.rrw-v svg{width:14px;height:14px;flex-shrink:0}',
    '.rrw-card__date{font-size:12.5px;color:#999;margin-top:3px}',
    '.rrw-card__stars{color:#6c47ff;font-size:17px;letter-spacing:2px;margin:9px 0 7px;line-height:1}',
    '.rrw-card__title{font-weight:700;color:#121212;font-size:15px;margin-bottom:4px;line-height:1.4}',
    '.rrw-card__body{color:#333;font-size:15px;line-height:1.55;overflow-wrap:anywhere}',
    '.rrw-card__prod{display:flex;align-items:center;gap:10px;margin-top:13px;padding-top:13px;border-top:1px solid #eee;text-decoration:none;color:#444}',
    'a.rrw-card__prod:hover .rrw-card__pname{color:#6c47ff}',
    '.rrw-card__pthumb{width:48px;height:48px;border-radius:6px;overflow:hidden;background:#f3f0ff;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:22px}',
    '.rrw-card__pthumb img{width:100%;height:100%;object-fit:cover;display:block}',
    '.rrw-card__pname{font-size:12.5px;line-height:1.35;transition:color .2s}',
    '.rrw__more-wrap{text-align:center;padding:24px 0 0}',
    '.rrw__more{display:inline-block;padding:12px 30px;background:#6c47ff;color:#fff !important;border:none;border-radius:10px;font-weight:700;font-size:15px;cursor:pointer;text-decoration:none}',
    '.rrw__more:hover{opacity:.9}',
    '@media (max-width:600px){.rrw__head{align-items:flex-start}.rrw__all{padding:9px 16px;font-size:13.5px}' +
      '.rrw__grid,.rrw__col{gap:10px}.rrw-card__in{padding:11px 11px 10px}.rrw-card__name{font-size:12.5px;gap:3px 6px}' +
      '.rrw-v{font-size:11px}.rrw-v svg{width:12px;height:12px}.rrw-card__date{font-size:11px}' +
      '.rrw-card__stars{font-size:14px;letter-spacing:1px;margin:7px 0 6px}.rrw-card__title,.rrw-card__body{font-size:13px;line-height:1.5}' +
      '.rrw-card__prod{gap:8px;margin-top:10px;padding-top:10px}.rrw-card__pthumb{width:40px;height:40px;font-size:18px}.rrw-card__pname{font-size:11px}}'
  ].join('');

  var VCHECK = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#121212"/><path d="M5.8 10.3l2.7 2.7 5.7-5.9" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function attr(s) { return esc(s).replace(/"/g, '&quot;'); }
  function starStr(n) { var s = ''; for (var i = 0; i < 5; i++) s += i < n ? '★' : '☆'; return s; }
  function shortDate(ts) { if (!ts) return ''; try { return new Date(ts).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; } }
  function fmt(n) { try { return Number(n).toLocaleString('en-GB'); } catch (e) { return String(n); } }
  function heroSrc(p) { var s = p.thumb || p.full || ''; return /width=\d+/.test(s) ? s.replace(/width=\d+/, 'width=520') : (p.full || s); }

  function addCss() {
    if (document.getElementById('rrw-css')) return;
    var st = document.createElement('style'); st.id = 'rrw-css'; st.textContent = CSS;
    document.head.appendChild(st);
  }

  var dataPromise = null;
  function getData(src) {
    if (!dataPromise) dataPromise = fetch(src).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    return dataPromise;
  }

  function starsHtml(avg) {
    var pct = Math.max(0, Math.min(100, (avg / 5) * 100));
    return '<span class="rrw-stars" aria-hidden="true">★★★★★<span class="rrw-stars__on" style="width:' + pct.toFixed(1) + '%">★★★★★</span></span>';
  }

  function renderBadge(el, data) {
    var target = document.querySelector('[data-rrw-carousel]') ? '#rhapsodye-reviews' : ALL_REVIEWS_URL;
    var label = data.avg + ' out of 5 stars from ' + fmt(data.count) + ' total reviews';
    el.innerHTML = '<a href="' + target + '" aria-label="' + attr(label) + '">' + starsHtml(data.avg) +
      '<span class="rrw-badge__avg">' + esc(data.avg) + '</span>' +
      '<span class="rrw-badge__count">' + fmt(data.count) + ' total reviews</span></a>';
    el.classList.add('is-ready');
    var a = el.querySelector('a');
    if (target.charAt(0) === '#') {
      a.addEventListener('click', function (e) {
        var c = document.getElementById('rhapsodye-reviews');
        if (!c) return;
        e.preventDefault();
        // build the grid first so the page doesn't grow mid-scroll
        Promise.resolve(c.__rrwGo ? c.__rrwGo() : null).then(function () {
          c.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
  }

  var pimg = {};
  function productImg(url) {
    var m = /\/products\/([^\/?#]+)/.exec(url || '');
    if (!m) return Promise.resolve(null);
    var h = m[1];
    if (!pimg[h]) pimg[h] = fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      var s = p && (p.featured_image || (p.images && p.images[0]));
      if (!s) return null;
      if (s.indexOf('//') === 0) s = 'https:' + s;
      return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=100';
    }).catch(function () { return null; });
    return pimg[h];
  }

  function cardHtml(rv) {
    var h = '<article class="rrw-card">';
    if (rv.pic) {
      h += '<a class="rrw-card__hero" href="' + attr(rv.pic.full) + '" target="_blank" rel="nofollow"><img loading="lazy" src="' + attr(heroSrc(rv.pic)) + '" alt="Photo from ' + attr(rv.author) + '">';
      if (rv.picCount > 1) h += '<span class="rrw-card__count">📷 ' + rv.picCount + '</span>';
      h += '</a>';
    }
    h += '<div class="rrw-card__in">';
    h += '<div class="rrw-card__name">' + esc(rv.author) + (rv.verified ? '<span class="rrw-v">' + VCHECK + 'Verified</span>' : '') + '</div>';
    h += '<div class="rrw-card__date">' + esc(shortDate(rv.ts)) + '</div>';
    h += '<div class="rrw-card__stars" role="img" aria-label="' + rv.score + ' out of 5 stars">' + starStr(rv.score) + '</div>';
    if (rv.title) h += '<div class="rrw-card__title">' + esc(rv.title) + '</div>';
    h += '<div class="rrw-card__body">' + esc(rv.body) + '</div>';
    if (!rv.isShop && rv.product) {
      h += '<a class="rrw-card__prod" href="' + attr(rv.url) + '"><span class="rrw-card__pthumb" data-purl="' + attr(rv.url) + '">🧶</span><span class="rrw-card__pname">' + esc(rv.product) + '</span></a>';
    }
    h += '</div></article>';
    return h;
  }

  var PAGE = 12;

  // Masonry like /pages/reviews: each card drops into the shortest column, so
  // "Load more" adds to the bottom without moving cards already on screen.
  function renderGrid(el, data) {
    var reviews = data.reviews || [];
    var shown = 0, cols = [], nCols = 0;
    el.innerHTML = '<div class="rrw__head"><div><h2 class="rrw__title">What Our Customers Are Saying</h2>' +
      '<div class="rrw__summary">' + starsHtml(data.avg) + '<span><b>' + esc(data.avg) + '</b> from ' + fmt(data.count) + ' total reviews</span></div></div>' +
      '<a class="rrw__all" href="' + ALL_REVIEWS_URL + '">See all reviews</a></div>' +
      '<div class="rrw__grid" aria-label="Customer reviews"></div><div class="rrw__more-wrap"></div>';
    var grid = el.querySelector('.rrw__grid'), more = el.querySelector('.rrw__more-wrap');

    function colCount() { var w = grid.clientWidth || el.clientWidth || window.innerWidth; return w >= 900 ? 4 : (w >= 600 ? 3 : (w >= 260 ? 2 : 1)); }
    function resetCols() {
      nCols = colCount(); grid.innerHTML = ''; cols = [];
      for (var i = 0; i < nCols; i++) { var c = document.createElement('div'); c.className = 'rrw__col'; grid.appendChild(c); cols.push(c); }
    }
    function place(rv) {
      var tmp = document.createElement('div'); tmp.innerHTML = cardHtml(rv);
      var card = tmp.firstChild, best = cols[0];
      for (var i = 1; i < cols.length; i++) if (cols[i].offsetHeight < best.offsetHeight) best = cols[i];
      best.appendChild(card);
      card.querySelectorAll('.rrw-card__pthumb[data-purl]').forEach(function (t) {
        productImg(t.getAttribute('data-purl')).then(function (src) { if (src) t.innerHTML = '<img loading="lazy" src="' + attr(src) + '" alt="">'; });
      });
    }
    function showMore(n, from) {
      var end = Math.min(reviews.length, n);
      for (var i = from; i < end; i++) place(reviews[i]);
      shown = end;
      more.innerHTML = shown < reviews.length
        ? '<button type="button" class="rrw__more">Load more reviews</button>'
        : '<a class="rrw__more" href="' + ALL_REVIEWS_URL + '">See all ' + fmt(data.count) + ' reviews</a>';
      var btn = more.querySelector('button');
      if (btn) btn.addEventListener('click', function () { showMore(shown + PAGE, shown); });
    }
    resetCols();
    showMore(PAGE, 0);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { if (colCount() !== nCols) { var n = shown; resetCols(); showMore(n, 0); } }, 200);
    });
  }

  function init() {
    var badges = document.querySelectorAll('[data-rrw-badge]');
    var carousels = document.querySelectorAll('[data-rrw-carousel]');
    if (!badges.length && !carousels.length) return;
    var srcEl = document.querySelector('[data-rrw-src]');
    if (!srcEl) return;
    var src = srcEl.getAttribute('data-rrw-src');
    addCss();

    if (badges.length) {
      getData(src).then(function (d) { badges.forEach(function (b) { renderBadge(b, d); }); })
        .catch(function () { badges.forEach(function (b) { b.style.display = 'none'; }); });
    }
    carousels.forEach(function (c) {
      var done = null, io = null;
      function go() {
        if (done) return done;
        if (io) io.disconnect();
        done = getData(src).then(function (d) { renderGrid(c, d); }).catch(function () { c.style.display = 'none'; });
        return done;
      }
      c.__rrwGo = go;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) go();
        }, { rootMargin: '800px 0px' });
        io.observe(c);
      } else { go(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
